import './cardItemSkeleton.scss';

export const CardItemSkeleton = () => {
  return (
    <div className='card-item d-flex flex-column align-items-center'>
      <div className="skeleton-card-item--title"></div>
      <div className="skeleton-card-item--number"></div>
    </div>
  )
}
